import { helper } from '@ember/component/helper';
import { isPresent } from '@ember/utils';

const isPresentHelper = helper(([check]: any[] /*, hash*/) => {
  return isPresent(check);
});

export default isPresentHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-present': typeof isPresentHelper;
  }
}
